module.exports = __webpack_public_path__ + "img/panda_pavilion.4d65a8a8.jpg";